import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { NavLink } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Link, useSearchParams } from 'react-router-dom';
import Sidebar from './Sidebar'
import BACKEND_URL from '../../../api';
import '../../../My_Account.css'

export default function After_wallet_payment() {
  const [searchParams, setSearchParams] = useSearchParams();
  const orderno = searchParams.get("ref")
  const [isOpen, setIsOpen] = useState(false);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const [paymentstats, setstatus] = useState()
  const API_payment = `${BACKEND_URL}/checkWalletPayment`;

  useEffect(() => {
    console.log("orderno-------", orderno)
    axios({
      method: 'post',
      url: `${API_payment}`,
      data: { orderno: orderno }
    })
      .then((res) => {
        console.log("checkWalletPayment-------", res.data)
        setstatus(res.data.msg)
      })
      .catch((err) => console.log(err))
  }, [])

  return (
    <div className="my_parcels">
      <Helmet>
        <title>Shypv | After Payment</title>
      </Helmet>
      <div className="myparctab" style={{ padding: "0" }}>

        <div className="container-fluid" style={{ padding: "0" }}>
          <div className="row1">
            <Sidebar isOpen={isOpen} />

            <div id="admin-main-control" className="col-md-9 p-x-3 p-y-1" style={{ overflow: "auto", backgroundColor: "#f1f5f9" }}>
              <div style={{ boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)" }}>
                <nav className="navbar navbar-expand-lg navbar-light bg-light">
                  <div className="container-fluid" style={{ justifyContent: "space-between" }}>
                    <button className="navbar-toggler" type="button" onClick={toggleSidebar}>
                      {
                        isOpen ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="32"
                            height="32"
                            className="bi bi-arrow-bar-left"
                            viewBox="0 0 16 16"
                          >
                            <path
                              fillRule="evenodd"
                              d="M12.5 15a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 1 0v13a.5.5 0 0 1-.5.5M10 8a.5.5 0 0 1-.5.5H3.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L3.707 7.5H9.5a.5.5 0 0 1 .5.5"
                            />
                          </svg>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="32"
                            height="32"
                            className="bi bi-arrow-bar-right"
                            viewBox="0 0 16 16"
                          >
                            <path
                              fillRule="evenodd"
                              d="M6 8a.5.5 0 0 0 .5.5h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L12.293 7.5H6.5A.5.5 0 0 0 6 8m-2.5 7a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 1 0v13a.5.5 0 0 1-.5.5"
                            />
                          </svg>
                        )
                      }
                    </button>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                      <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="offset-1 collapse navbar-collapse" id="navbarNav">
                      <ul className="navbar-nav">
                        <>
                          <li className="nav-item">
                            <NavLink activeclassname="active" exact to="/">HOME</NavLink>
                            {/* <Link className="nav-link active"  aria-current="page" exact  to="/">HOME  </Link> */}
                          </li>
                          <li className="nav-item">
                            <NavLink exact to="/track">TRACK</NavLink>
                            {/* <Link className="nav-link" exact  to="/track">TRACK</Link> */}
                          </li>

                          {/* <li className="nav-item">
                                                            <NavLink exact to="/smart-send">SMART SEND</NavLink>
                                                        </li>
                                                        <li className="nav-item">
                                                            <NavLink exact to="/your-business">YOUR BUSINESS</NavLink>
                                                        </li>
                                                        <li className="nav-item">
                                                            <NavLink exact to="/help">HELP</NavLink>
                                                        </li>
                                                        <li className="nav-item">
                                                            <NavLink exact to="/become-a-partner">PARTNERS</NavLink>
                                                        </li>
                                                        <li className="nav-item">
                                                            <NavLink exact to="/parcels-on-demand">HOW IT WORKS</NavLink>
                                                        </li>
                                                        <li className="nav-item">
                                                            <a href="https://www.tymexlogistics.com/" target="_blank">LOGISTICS</a>
                                                        </li>
                                                        <li className="nav-item">
                                                            <NavLink exact to="/client-zone">CLIENT ZONE</NavLink>
                                                        </li> */}
                        </>
                      </ul>
                    </div>
                  </div>
                </nav>
              </div>
              <div style={{ margin: "20px", padding: "20px", backgroundColor: "white", boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)" }}>
                <h3>{paymentstats}</h3>
                <Link style={{ backgroundColor: '#2c4079', color: '#fff', padding: '14px 16px', display: 'inline-block', fontSize: '16px', fontWeight: 'bold' }} to="/my-account/my-wallet">Go to My Wallet</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
